import { z } from 'zod'

export const MailServerHealth = z.object({
  status: z.enum(['healthy', 'degraded', 'unhealthy']),
  stalwart_reachable: z.boolean(),
  queue_healthy: z.boolean(),
  components: z.record(z.string(), z.object({
    status: z.enum(['ok', 'warning', 'error']),
    message: z.string().optional()
  })).optional(),
  last_check: z.string().optional()
})

export type MailServerHealth = z.infer<typeof MailServerHealth>

export const QueuedMessage = z.object({
  id: z.number(),
  from: z.string(),
  to: z.array(z.string()),
  subject: z.string().optional(),
  retry_count: z.number(),
  next_retry: z.string().optional(),
  queued_at: z.string(),
  size: z.number().optional()
})

export type QueuedMessage = z.infer<typeof QueuedMessage>

export const MailQueueStatus = z.object({
  running: z.boolean().optional(),
  pending: z.number(),
  messages: z.array(QueuedMessage).optional()
})

export type MailQueueStatus = z.infer<typeof MailQueueStatus>

export const DomainMailStats = z.object({
  messages_in: z.number(),
  messages_out: z.number(),
  spam_rejected: z.number()
})

export type DomainMailStats = z.infer<typeof DomainMailStats>

export const MailServerStats = z.object({
  messages_in_total: z.number(),
  messages_out_total: z.number(),
  spam_rejected_total: z.number(),
  auth_failures_total: z.number(),
  bytes_in_total: z.number(),
  bytes_out_total: z.number(),
  domains: z.record(z.string(), DomainMailStats).optional(),
  period: z.enum(['day', 'week', 'month']).optional()
})

export type MailServerStats = z.infer<typeof MailServerStats>
